<template>
  <v-sheet
    :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'"
  >
    <v-row dense>
      <v-col cols="12" xl="12" class="custom-border">
        <v-card
          elevation="0"
          class="rounded-0 mb-0"
          :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'"
        >
          <v-tabs
            :background-color="$vuetify.theme.dark ? 'transparent ' : 'transparent'"
            class="pa-0 commission-settings-tabs"
          >
            <v-tab class="ml-0 pt-1"> General T&C For IB</v-tab>
            <v-tab> IB’s Agreement History </v-tab>
            

            <v-tab-item>
              <v-card
                flat
                class="mb-0 pt-2"
                :color="$vuetify.theme.dark ? 'transparent ' : 'transparent'"
              >
                <ib-terms-tab></ib-terms-tab>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <ib-agreement-tab></ib-agreement-tab>
            </v-tab-item>
            
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import IbAgreementTab from './IbAgreementTab.vue';
import IbTermsTab from './IbTermsTab.vue';


export default {
  data: () => ({}),
  components: {
    IbTermsTab,
    IbAgreementTab
  },
};
</script>